import type { PageProps, PlatformPageProps } from "@/types";
import React, { FC } from "react";
import {
  PlatformCards,
  PlatformDeploymentOptions,
  PlatformFintechApps,
  PlatformGlobalSingleSharedPlatform,
  PlatformGreatForSlides,
  PlatformHero,
  PlatformInclusivePaymentOptions,
  PlatformLocalPaymentOptions,
  PlatformRegulations,
  PlatformReplaceData,
  PlatformSolvingDeficiencies,
} from "../platform";

export const Platform: FC<PageProps<PlatformPageProps>> = (props) => {
  return (
    <div>
      <PlatformHero
        label={props.meta.translation.platform.hero.label}
        title={props.data.title}
        description={props.data.description}
        cover={props.data.cover}
      />
      <PlatformReplaceData {...props.data.replaceData} />
      <PlatformGlobalSingleSharedPlatform
        {...props.data.globalSingleSharedPlatform}
      />
      <PlatformLocalPaymentOptions content={props.data.localPaymentOptions} cards={props.data.paymentChannelOptionsCards} />
      <PlatformSolvingDeficiencies
        title={props.data.solvingDeficienciesTitle}
        cards={props.data.solvingDeficienciesCards}
      />
      <PlatformRegulations
        text={props.data.regulationsText}
        image={props.data.regulationsImage}
      />
      <PlatformCards cards={props.data.cards} />
      <PlatformInclusivePaymentOptions
        content={props.data.inclusivePaymentOptions}
      />
      <PlatformDeploymentOptions
        title={props.data.deploymentOptionsTitle}
        cards={props.data.deploymentOptionsCards}
        cta={props.data.deploymentOptionsCta}
      />
      <PlatformFintechApps content={props.data.fintechApps} />
      <PlatformGreatForSlides
        you={props.data.greatForYouSlides}
        customers={props.data.greatForYourCustomersSlides}
      />
    </div>
  );
};
